@if (homepageContent === 'messages') {
  <app-messages [messages]="messages" [totalItems]="totalMessages" (pageChange)="onPageChange($event)" (deviceFilterChange)="onDeviceFilterChange($event)"></app-messages>
} @else if (homepageContent === 'get-started-with-multinode') {
  <app-get-started-with-multinode [profile]="profile"></app-get-started-with-multinode>
} @else if (homepageContent === 'get-started') {
  <app-get-started></app-get-started>
} @else if (homepageContent === 'loading') {
  <app-loading></app-loading>
}

<!--<div class="ml-4 mt-8">-->
<!--  <p class="ml-4 text-error">Dev only:</p>-->
<!--  <div role="tablist" class="tabs tabs-bordered mb-6">-->
<!--    <button-->
<!--      role="tab"-->
<!--      class="tab"-->
<!--      [class.tab-active]="homepageContent === 'get-started-with-multinode'"-->
<!--      (click)="switchPage('get-started-with-multinode')">-->
<!--      Get Started-->
<!--    </button>-->
<!--    <button-->
<!--      role="tab"-->
<!--      class="tab"-->
<!--      [class.tab-active]="homepageContent === 'messages'"-->
<!--      (click)="switchPage('messages')">-->
<!--      Messages-->
<!--    </button>-->
<!--    <button-->
<!--      role="tab"-->
<!--      class="tab"-->
<!--      [class.tab-active]="homepageContent === 'get-started'"-->
<!--      (click)="switchPage('get-started')">-->
<!--      Get Started -no multinode- -->
<!--    </button>-->
<!--    <button-->
<!--      role="tab"-->
<!--      class="tab"-->
<!--      [class.tab-active]="homepageContent === 'loading'"-->
<!--      (click)="switchPage('loading')">-->
<!--      Loading-->
<!--    </button>-->
<!--  </div>-->
<!--</div>-->
